import React from "react";
import { mainTheme } from "../../../globalStyles/themes/mainTheme";
import {
  StyledConfimDeleteWrapper,
  StyledDeleteBtn,
} from "./StylesConfirmDelete";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../redux/actions";
import {
  usersCollection,
  bookingsCollection,
  parkingsCollection,
} from "../../../firebase/firestoreUtils";

const ConfirmDelete = ({
  children,
  bgColor = mainTheme.colors.redDelete,
  onCancel,
  type,
  whatToDelete,
  collectionName,
  objectId,
}) => {
  const dispatch = useDispatch();

  const onDelete = () => {
    if (collectionName === "users") {
      usersCollection
        .doc(objectId)
        .delete()
        .then(() => window.location.reload())
        .catch((err) => console.log(err));
    }

    if (collectionName === "bookings") {
      bookingsCollection
        .doc(objectId)
        .delete()
        .then(() => window.location.reload())
        .catch((err) => console.log(err));
    }

    if (collectionName === "parkings") {
      parkingsCollection
        .doc(objectId)
        .delete()
        .then(() => {
          usersCollection
            .where("parkingId", "==", objectId)
            .get()
            .then((response) => {
              response.docs.forEach((el) => {
                if (el.data().role === "user" || el.data().role === "admin") {
                  el.delete();
                }
              });
            });
        })
        .then(() => window.location.reload());
    }
  };

  return (
    <StyledConfimDeleteWrapper>
      <h2 className="info">Are you sure to delete this {whatToDelete}?</h2>
      <div className="btn-wrapper">
        <StyledDeleteBtn
          bgColor={"#033076"}
          onClick={() => dispatch(closeModal())}
          type={type}
        >
          Cancel
        </StyledDeleteBtn>
        <StyledDeleteBtn bgColor={bgColor} onClick={onDelete} type={type}>
          Delete
        </StyledDeleteBtn>
      </div>
    </StyledConfimDeleteWrapper>
  );
};

export default ConfirmDelete;
